import React from "react";
import StatusCircle from "../StatusCircle";
import { CardTitle } from "reactstrap";

const BroadCastTitle = ({ userName, userImage, isTitle, status }) => {
  return (
    <React.Fragment>
      <StatusCircle isTitle={isTitle} status={status && status} />
      <CardTitle>
        <img
          src={userImage}
          alt="user image"
          className="rounded-circle mr-2"
          width="40"
          height="40"
        />
        <span className="profiletitlename">{userName}</span>
      </CardTitle>
    </React.Fragment>
  );
};

export default BroadCastTitle;
